export default "__VITE_ASSET__DYcAk8Fa__"